__turbopack_context__.v({
  "itemListWrapper": "y_UMkG_itemListWrapper",
  "itemListWrapperColumned": "y_UMkG_itemListWrapperColumned",
});
